const LAST_REFRESH_DEPLOY_KEY = 'version_last_refresh_deploy';

export class VersionRefreshGuard {

    private currentDeployTimestamp: number = 0;

    isAlreadyAttempted(): boolean {
        if (!this.currentDeployTimestamp) {
            return false;
        }

        const lastRefreshDeploy = this.getLastRefreshDeploy();

        if (!lastRefreshDeploy) {
            return false;
        }
        return lastRefreshDeploy >= this.currentDeployTimestamp;
    }

    trackDeploy(deployTimestamp: number): void {
        this.currentDeployTimestamp = deployTimestamp;
    }

    save(): void {
        if (!this.currentDeployTimestamp) {
            return;
        }
        sessionStorage.setItem(LAST_REFRESH_DEPLOY_KEY, String(this.currentDeployTimestamp));
    }

    private getLastRefreshDeploy(): number | null {
        const stored = sessionStorage.getItem(LAST_REFRESH_DEPLOY_KEY);

        if (!stored) {
            return null;
        }

        return Number(stored);
    }
}
